// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const sepOperations = {
  HealthController_getHealthCheck: ['get', '/'] as const,
  CommonSegmentationController_getAllCommonSegmentationPrograms: [
    'get',
    '/common-segmentation'
  ] as const,
  CommonSegmentationController_getCommonSegmentationProgramById: [
    'get',
    '/common-segmentation/{id}'
  ] as const,
  SepProgramController_create: ['post', '/sep-programs'] as const,
  SepProgramController_getSupplierAuditResultsBySupplierNumbers: [
    'post',
    '/sep-programs/audits'
  ] as const,
  SepProgramController_findSEPProgramByCSProgramId: [
    'get',
    '/sep-programs/{csProgramId}'
  ] as const,
  SepProgramController_editSEPProgramByProgramId: [
    'put',
    '/sep-programs/{programId}'
  ] as const,
  SepProgramController_getSearchAll: ['post', '/sep-programs/search'] as const,
  SepProgramController_bulkUpdateSciLead: [
    'post',
    '/sep-programs/bulk-update/sci-lead'
  ] as const,
  SepProgramController_getIntendToQuoteSuppliers: [
    'post',
    '/sep-programs/intend-to-quote-suppliers'
  ] as const,
  SepProgramController_getSpendCurRepAndPDPRepByProgramId: [
    'get',
    '/sep-programs/spend-by-supplier'
  ] as const,
  SepProgramController_getNonStrategicIntendToQuoteSuppliers: [
    'get',
    '/sep-programs/{csProgramId}/non-strategic-intend-to-quote-suppliers'
  ] as const,
  SepProgramController_getQBicSummary: ['get', '/sep-programs/qbic'] as const,
  SepProgramController_getAESummary: ['get', '/sep-programs/ae'] as const,
  SepProgramController_getDmsmSummary: ['get', '/sep-programs/dmsm'] as const,
  SepProgramController_getOverallRiskSummary: [
    'get',
    '/sep-programs/risk/overall'
  ] as const,
  SepProgramController_getDeliveryRiskSummary: [
    'get',
    '/sep-programs/risk/delivery'
  ] as const,
  SepProgramController_getHighRiskSuppliers: [
    'get',
    '/sep-programs/risk/high-risk-suppliers'
  ] as const,
  SepProgramController_getSocioeconomicIndicatorSummary: [
    'get',
    '/sep-programs/socioeconomic-indicators'
  ] as const,
  SepProgramController_getResiliencySummary: [
    'get',
    '/sep-programs/resiliency'
  ] as const,
  SepProgramController_getInterfactorySummary: [
    'get',
    '/sep-programs/interfactory'
  ] as const,
  SepProgramController_getNewSuppliers: [
    'get',
    '/sep-programs/{csProgramId}/new-suppliers'
  ] as const,
  SepProgramController_findCriticalSuppliersByCSProgramId: [
    'get',
    '/sep-programs/{csProgramId}/critical-suppliers'
  ] as const,
  SepProgramController_getPartsAwardedToPlanSummary: [
    'get',
    '/sep-programs/{csProgramId}/parts-awarded-to-plan'
  ] as const,
  SepProgramController_getMisCostQualitySummary: [
    'get',
    '/sep-programs/{csProgramId}/mis-quality-of-cost'
  ] as const,
  SepProgramController_getDmsmPartsSummary: [
    'get',
    '/sep-programs/{csProgramId}/rep-machine-dmsm-parts'
  ] as const,
  SepProgramScoreCardController_captureProgramScorecardSnapshot: [
    'post',
    '/sep-programs/{programId}/create-scorecard-snapshot'
  ] as const,
  SepProgramScoreCardController_findBOMInfoByProgramId: [
    'get',
    '/sep-programs/{programId}/scorecard-bom-info'
  ] as const,
  PlanController_createPlans: ['post', '/plans'] as const,
  PlanController_findAllPlans: ['get', '/plans'] as const,
  PlanController_updateSinglePlan: ['put', '/plans/{planId}'] as const,
  PlanController_findPlanByPlanId: ['get', '/plans/{planId}'] as const,
  PlanController_deletePlanByPlanId: ['delete', '/plans/{planId}'] as const,
  PlanController_createPlanStatus: [
    'post',
    '/plans/{planId}/plan-status'
  ] as const,
  PlanController_getAllStatuses: [
    'get',
    '/plans/{planId}/plan-status'
  ] as const,
  PlanController_getDecoratedPartsForPlan: [
    'get',
    '/plans/{planId}/parts-decorated'
  ] as const,
  PlanController_bulkUpdateSciOwner: [
    'post',
    '/plans/bulk-update/sci-owner'
  ] as const,
  PlanController_patchPlanQualityComments: [
    'patch',
    '/plans/{planId}/quality-comments'
  ] as const,
  SciOwnersController_getSciOwners: ['get', '/sci-owners'] as const,
  SciLeadsController_retrieveAllSavedSciLeadIds: ['get', '/sci-leads'] as const,
  createSepProgramGate0Feedback: [
    'post',
    '/sep-programs/{programId}/gate0-feedback'
  ] as const,
  DmsmSpendController_getSpendByStrategyNumber: ['get', '/dmsm-spend'] as const,
  DmsmSpendController_getSupplierPartsSummary: [
    'post',
    '/dmsm-spend/supplier-parts'
  ] as const,
  DmsmSpendController_getUniqueSupplierNumbers: [
    'get',
    '/dmsm-spend/supplier-numbers'
  ] as const,
  DmsmSpendController_getPartsBySuppliers: [
    'post',
    '/dmsm-spend/supplier-parts/details'
  ] as const,
  PartsController_getPartsEpdmPartsByProgramId: ['get', '/parts'] as const,
  PartsController_refreshPartsOnTheFly: [
    'get',
    '/parts/refreshOnTheFly'
  ] as const,
  PartsController_getIntendToQuoteSuppliersForParts: [
    'post',
    '/parts/intend-to-quote-suppliers'
  ] as const,
  SchedulingAgreementController_getSchedulingAgreementData: [
    'post',
    '/schedulingAgreement'
  ] as const,
  RepMachineController_isValidPdpRepMachineNumber: [
    'get',
    '/rep-machines/pdp/check-validity'
  ] as const,
  RepMachineController_getCurrentRepMachinesPartsByRepNumber: [
    'post',
    '/rep-machines/parts'
  ] as const,
  RepMachineController_getPdpRepMachinesPartsByRepNumber: [
    'post',
    '/pdp-rep-machines/parts'
  ] as const,
  StrategyController_getStrategyPlanDetailsByStrategyNumber: [
    'get',
    '/strategies/{strategyNumber}'
  ] as const,
  OnDemandBatchJobController_runPdpRepMachinesBOMBatchProgram: [
    'get',
    '/batch-jobs-on-demand/pdp-rep-machines-bom'
  ] as const,
  OnDemandBatchJobController_runCurrentRepMachinesBOMBatchProgram: [
    'get',
    '/batch-jobs-on-demand/current-rep-machines-bom'
  ] as const,
  OnDemandBatchJobController_runEpdmPartsBatchProgram: [
    'get',
    '/batch-jobs-on-demand/epdm-parts'
  ] as const,
  OnDemandBatchJobController_runDmsmPartsBatchProgram: [
    'get',
    '/batch-jobs-on-demand/dmsm-parts'
  ] as const,
  OnDemandBatchJobController_runLowRepMachineBOMValidityBatchProgram: [
    'get',
    '/batch-jobs-on-demand/low-rep-machine-bom-validity'
  ] as const,
  UnitCodeTranslationController_getTranslatedUnitCode: [
    'get',
    '/unit-code-translation'
  ] as const,
  AttachmentsController_uploadAttachment: [
    'post',
    '/sep-programs/{csProgramId}/attachments'
  ] as const,
  AttachmentsController_findAll: [
    'get',
    '/sep-programs/{csProgramId}/attachments'
  ] as const,
  AttachmentsController_findOne: [
    'get',
    '/sep-programs/{csProgramId}/attachments/{attachmentId}'
  ] as const,
  AttachmentsController_remove: [
    'delete',
    '/sep-programs/{csProgramId}/attachments/{attachmentId}'
  ] as const
} as const;
